import type { ReactNode } from 'react'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'

export interface PageTabItem<TValue extends string> {
  value: TValue
  label: ReactNode
}

interface PageTabsHeaderProps<TValue extends string> {
  tabs: Array<PageTabItem<TValue>>
  activeTab: TValue
  onTabChange?: (tab: TValue) => void
}

export function PageTabsHeader<TValue extends string>({
  tabs,
  activeTab,
  onTabChange,
}: PageTabsHeaderProps<TValue>) {
  return (
    <div className="min-h-[46px] py-1">
      <Tabs
        value={activeTab}
        onValueChange={(value) => onTabChange?.(value as TValue)}
        className="min-h-[38px] justify-end gap-0"
      >
        <TabsList variant="underline" className="pl-1 md:pl-5 pr-4 md:pr-8">
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value} variant="underline">
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  )
}
